import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { Tools } from "@comunicare/comunicare-helper";
import { AccessValue, IPractitionerAccess } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

export class PractitionerAccessListDataSource extends MatTableDataSourceExtended<IPractitionerAccess> {
  sortingDataAccessor = (data: IPractitionerAccess, sortHeaderId: string) => {
    switch (sortHeaderId) {
      case "theme":
        return this.normalize(data?.theme);
      case "method":
        return data?.method ? this.normalize(this.translateService.instant("groupPermission." + data.method)) : "";
      case "routeName":
        return this.normalize(data?.routeName);
      default: {
        // Group columns use the group name as sortHeaderId: sort on the access displayed for that group
        const groupAccess = data?.accessesByGroups?.find((a) => a.accessGroupName === sortHeaderId)?.access ?? AccessValue.UNDEFINED;
        return this.normalize(this.translateService.instant("groupPermission." + groupAccess));
      }
    }
  };

  constructor(private translateService: TranslateService) {
    super();
  }

  public loadData(accesses: IPractitionerAccess[]) {
    this.data = accesses;
  }

  /**
   * Case and accent insensitive value, otherwise uppercase and accented strings are not sorted alphabetically
   */
  private normalize(value: string): string {
    return value ? Tools.suppressDiacritics(value).toLowerCase() : "";
  }
}
